import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import ListingCard from "../ListingCard";
import { useI18n } from "../../i18n/I18nProvider";
import { Heart } from "lucide-react";

export default function SavedListings() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/saved")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-6 label-tech">{t("detail.loading")}</div>;

  if (items.length === 0) {
    return (
      <div className="text-center py-16">
        <Heart size={32} className="mx-auto text-[var(--ink-500)]" />
        <h3 className="font-display text-2xl mt-3">{t("saved.empty")}</h3>
        <p className="text-sm text-[var(--ink-700)] mt-2">{t("saved.emptyBody")}</p>
        <Link to="/marketplace" className="btn-primary mt-6 inline-flex" data-testid="saved-empty-browse-btn">{t("dash.browse")}</Link>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--ink-200)] border border-[var(--ink-200)]">
      {items.map((l) => <ListingCard key={l.id} listing={l} />)}
    </div>
  );
}
